(function () {
  class WinningsText extends PIXI.Container {
    constructor() {
      super();

      this._textAnimTimeline = null;
      this._multiplierTimeline = null;

      this._preMultiplier = 0;
      this._postMultiplier = 0;
      this._multiplier = 0;

      Reflex.registerEventHandler("ready", this.onReady.bind(this));
    }

    onReady() {
      this._container = resourceManager.get(
        this.name + ":winningsTextContainer"
      );

      this._blackMask = resourceManager.get(
        this.name + ":winningsTextContainer:blackmask"
      );

      this._winningsValue = resourceManager.get(
        this.name + ":winningsTextContainer:winningsText"
      );
      this._multiplierValue = resourceManager.get(
        this.name + ":winningsTextContainer:multiplierText"
      );
      this._multiplierSparks = resourceManager.get(
        this.name + ":winningsTextContainer:multiplierSparks"
      );

      this._totalWinText = resourceManager.get(
        this.name + ":winningsTextContainer:winningsTextTotalWin"
      );
      this._winningsTextBar = resourceManager.get(
        this.name + ":winningsTextContainer:winningsTextBar"
      );

      this.setupTweens();
      this.show(false);

      Reflex.deregisterEventHandler("ready", this.onReady.bind(this));
    }

    setupTweens() {
      const self = this;
      this._textAnimTimeline = gsap
        .timeline({ paused: true, delay: 0.5 })
        // scale in pre-multiplier win value
        .call(
          () => {
            this._winningsValue.setText(gdk.formatCurrency(0));
          },
          null,
          0
        )
        .fromTo(
          this._winningsValue.scale,
          { x: 0, y: 0 },
          {
            duration: 0.5,
            ease: "back.out(1)",
            x: 0.7,
            y: 0.7,
            onUpdate: function () {
              self._winningsValue.setText(
                gdk.formatCurrency(this.progress() * self._preMultiplier)
              );
            },
            onComplete: () => {
              this._winningsValue.setText(
                gdk.formatCurrency(this._preMultiplier)
              );
              soundManager.stop("winCountUp");
            },
          }
        )
        // move win value up to make room for multiplier
        .to(this._winningsValue, {
          duration: 1,
          ease: "back.out(1)",
          y: this._winningsValue.position.y - 130,
          onStart: () => {},
          onComplete: () => {
            this._multiplierSparks.visible = true;
            this._multiplierSparks.gotoAndPlay(0);
            soundManager.play("multiplierApplied");
          },
        })
        // move back down & set win value to post-multiplier winnings
        .to(this._winningsValue, {
          duration: 0.5,
          ease: "back.out(1)",
          y: this._winningsValue.position.y,
          onStart: () => {
            this._winningsValue.setText(
              gdk.formatCurrency(this._postMultiplier)
            );
          },
        });

      this._multiplierTimeline = gsap
        .timeline({ paused: true, delay: 0.5 })
        // scale in multiplier
        .call(
          () => {
            this._multiplierValue.visible = false;
            this._multiplierValue.scale = 0;
            this._multiplierValue.setText(`x${this._multiplier}`);
          },
          null,
          0
        )
        .call(
          () => {
            this._multiplierValue.visible = true;
          },
          null,
          1
        )
        .fromTo(
          this._multiplierValue.scale,
          { x: 0, y: 0 },
          {
            duration: 1,
            ease: "circ.inOut",
            x: 1,
            y: 1,
          }
        )
        // move multiplier
        .to(this._multiplierValue, {
          duration: 0.5,
          ease: "back.out(2)",
          alpha: 0,
          y: this._multiplierValue.position.y - 50,
          onComplete: () => {
            this._multiplierValue.scale = 0;
            this._multiplierValue.position.y += 50;
            this._multiplierValue.alpha = 1;
            this._multiplierValue.visible = false;
            this._multiplierSparks.visible = false;
          },
        });
    }

    setText(value) {
      this._winningsValue.setText(gdk.formatCurrency(value));
    }

    show(show, value) {
      this._container.visible = show;

      if (value) this.setText(value);
    }

    setWinText(showWinText) {
      if (showWinText) {
        this._totalWinText.visible = false;
        this._winningsTextBar.visible = false;
        this._blackMask.alpha = 0.3;
      } else {
        this._totalWinText.visible = true;
        this._winningsTextBar.visible = true;
        this._blackMask.alpha = 0.3;
      }
    }

    playDiamondAnimation() {}

    setScale(scale) {
      this._container.scale.set(scale);
    }

    animateMultiplyingWin(preMultiplier, multiplier, postMultiplier, progress) {
      this._preMultiplier = preMultiplier;
      this._postMultiplier = postMultiplier;
      this._multiplier = multiplier;

      this._textAnimTimeline?.progress(progress).pause();
      this._multiplierTimeline?.progress(progress).pause();
    }
  }

  const winningsTextCreator = function (json) {
    return new WinningsText();
  };

  resourceManager.registerObjectType(
    "winningsText",
    winningsTextCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
